var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"install"},[_c('title-component',[_vm._v("App installieren")]),_c('strong',[_vm._v("Share -> Add to homescreen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }